module.exports = __webpack_public_path__ + "media/images/pc/specials/common/recommend_flower_2-e87b21213a179a6aab3841c243eb8d4b.jpg";